import { UserType } from "app/types/userType";
import { useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import "./WelcomeMessage.scss";
type Props = {
  user: UserType;
};

const WelcomeMessage = ({ user }: Props) => {
  const [firstName, setFirstName] = useState("");

  useEffect(() => {
    if (user && user.firstName) {
      setFirstName(user.firstName || "");
    }
  }, [user]);

  return (
    <div className="form-details__row welcome-message">
      <div className="welcome-username">
        <FormattedMessage id={"helpandlearning-welcome"} tagName="span" />
        <span>{firstName}</span>
      </div>
      <div className="welcome-text">
        <FormattedMessage id={"loss-limits-welcome-text"} tagName="span" />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.userModel.user,
});

export default connect(mapStateToProps, null)(injectIntl(WelcomeMessage));
